import Plot from "react-plotly.js";
import { DEFAULT_PLOTLY_CONFIG } from "src/constants/constants";
import {
  FILE_TYPE_COLORS,
  FILE_TYPE_LABELS,
  FILE_TYPES,
  regionShortLabel,
} from "../adminReportUtils";
import { RegionReport } from "../types";

/** Dashboard charts drop the mode bar; the data is already in the table beside it. */
const CHART_CONFIG = { ...DEFAULT_PLOTLY_CONFIG, displayModeBar: false };

const FilesByRegionChart = ({ regions }: { regions: RegionReport[] }) => {
  const regionLabels = regions.map(({ region }) => regionShortLabel(region));

  const data: any = FILE_TYPES.map((fileType) => ({
    type: "bar",
    orientation: "h",
    name: FILE_TYPE_LABELS[fileType],
    y: regionLabels,
    x: regions.map(({ fileCounts }) => fileCounts[fileType]),
    marker: { color: FILE_TYPE_COLORS[fileType] },
    hovertemplate: `%{y} ${FILE_TYPE_LABELS[fileType]}: %{x}<extra></extra>`,
  }));

  const layout: any = {
    barmode: "stack",
    bargap: 0.42,
    height: 36 * regions.length + 44,
    margin: { t: 8, r: 10, b: 28, l: 46 },
    showlegend: false,
    paper_bgcolor: "transparent",
    plot_bgcolor: "transparent",
    xaxis: {
      gridcolor: "#eef0f4",
      tickfont: { size: 10, color: "#8a94a6" },
      zeroline: false,
    },
    yaxis: {
      type: "category",
      autorange: "reversed",
      tickfont: { size: 10, color: "#5c6573" },
    },
  };

  return (
    <Plot
      className="admin-report__chart"
      data={data}
      layout={layout}
      config={CHART_CONFIG}
      useResizeHandler
      style={{ width: "100%" }}
    />
  );
};

export default FilesByRegionChart;
